export * from "ce/selectors/applicationSelectors";
import type { DefaultRootState } from "react-redux";
import type { WorkspaceUserRoles } from "ee/constants/workspaceConstants";
import { createSelector } from "reselect";
import {
  getRedeployApplicationTrigger as CE_getRedeployApplicationTrigger,
  getCurrentApplication,
} from "ce/selectors/applicationSelectors";
import { getPackages } from "ee/selectors/packageSelectors";
import {
  REDEPLOY_TRIGGERS,
  type RedeployTriggerValue,
} from "ee/constants/DeploymentConstants";

export const getAllAppUsers = (state: DefaultRootState) =>
  state.ui.applications.applicationUsers;

export const getAllAppRoles = (state: DefaultRootState) =>
  state.ui.applications.applicationRoles;

export const getAppRolesForField = createSelector(
  getAllAppRoles,
  (roles: WorkspaceUserRoles[] = []) => {
    // TODO: Fix this the next time the file is edited
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return roles.map((role: any) => {
      return {
        id: role?.id,
        name: role?.name,
        description: role?.description,
      };
    });
  },
);

export const getRedeployApplicationTrigger = createSelector(
  CE_getRedeployApplicationTrigger,
  getCurrentApplication,
  getPackages,
  (
    ceRedeployTrigger,
    currentApplication,
    packages,
  ): RedeployTriggerValue | null => {
    // First check CE condition (lastDeployedAt < modifiedAt)
    if (!ceRedeployTrigger) {
      return null;
    }

    if (!currentApplication?.lastDeployedAt || !packages) {
      return REDEPLOY_TRIGGERS.PendingDeployment;
    }

    const lastDeployedAtMs = new Date(
      currentApplication.lastDeployedAt,
    ).getTime();
    const packagesArray = Object.values(packages);

    // Then check EE condition (packages with lastPublishedAt > lastDeployedAt)
    const hasPendingPackage = packagesArray.some((pkg) => {
      if (!pkg.lastPublishedAt) {
        return false;
      }

      const lastPublishedAtMs = new Date(pkg.lastPublishedAt).getTime();

      return lastPublishedAtMs > lastDeployedAtMs;
    });

    if (hasPendingPackage) {
      return REDEPLOY_TRIGGERS.PendingDeploymentWithPackage;
    }

    return REDEPLOY_TRIGGERS.PendingDeployment;
  },
);
